module.exports = _.isInteger;